import { put } from './http'
import { EDIT_LIEN, EDIT_WALLET } from '../utils/routes'

export const editWallet = (payload, id) => put(`${EDIT_WALLET}/${id}`, payload)

export const editLien = (payload, id) => put(`${EDIT_LIEN}/${id}`, payload)
